export enum ActiveModal {
  CLI = 'CLI',
  SELF_HOSTED = 'SELF_HOSTED',
  BLOCKS = 'BLOCKS',
  NONE = '',
}
